export default "/25f710847dd0be805cb8ee54d4e27cd8317d2a0f/bce1c79c076cfd26ce49a1f2fa85ca50.svg";